import { render, staticRenderFns } from "./ProjectResultConfigItemChildModal.vue?vue&type=template&id=4c1cc1ae&scoped=true"
import script from "./ProjectResultConfigItemChildModal.vue?vue&type=script&lang=js"
export * from "./ProjectResultConfigItemChildModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1cc1ae",
  null
  
)

export default component.exports